import { Button, Card, Space, Tag, Typography } from 'antd';
import { MockBanner } from '../../../pages/components/MockBanner';
import { PageHeader } from '../../../pages/components/PageHeader';

/** Admin screen 14. Budget state shown before the approve button (M-07). */
export function InboxPage() {
  return (
    <div>
      <MockBanner when="the approvals engine" needs="rule-based routing (P-07)" />
      <PageHeader
        title="Action queue"
        subtitle="12 items · 4 delegated to VP automatically · routing by rule, not by person (P-07)"
        actions={<Button type="primary" disabled>Approve selected (3)</Button>}
      />

      <Space size={6} wrap style={{ marginBottom: 12 }}>
        <Filter active>All 12</Filter>
        <Filter>Purchases 4</Filter>
        <Filter>Leave 5</Filter>
        <Filter>Concessions 2</Filter>
        <Filter>Certificates 1</Filter>
      </Space>

      <Card size="small" title="Purchases" style={{ marginBottom: 12 }}>
        <ApproveRow
          who="A. Sharma · Mathematics coord"
          what="30 lab thermometers · vendor: Nachiket Scientific"
          amount="₹18,400"
          budget={<Tag color="success">In budget · ₹1.2L remaining</Tag>}
          action="Approve"
        />
        <ApproveRow
          who="V. Menon · Accounts"
          what="Printer toner + paper (Q3)"
          amount="₹4,200"
          budget={<Tag color="success">Auto-approve threshold (under ₹5k · in budget)</Tag>}
          action="Auto-approved 08:12"
          auto
        />
        <ApproveRow
          who="P. Iyer · Science"
          what="Chemistry lab renovation · vendor selected"
          amount="₹8,20,000"
          budget={<Tag color="error">Above principal limit · escalates to trust</Tag>}
          action="Escalate"
          last
        />
      </Card>

      <Card size="small" title="Leave" style={{ marginBottom: 12 }}>
        <ApproveRow
          who="K. Kaur · English"
          what="14–16 Sep · 3 days · daughter's marriage"
          amount="3 days · 6 periods to cover"
          budget={<Tag color="warning">2 periods still uncovered · propose auto-cover?</Tag>}
          action="Approve + cover"
        />
        <ApproveRow
          who="A. Iyer · Science"
          what="20 Sep · 1 day · medical"
          amount="1 day · 4 periods"
          budget={<Tag color="success">All periods covered by proxy</Tag>}
          action="Approve"
          last
        />
      </Card>

      <Card size="small" title="Fee concessions">
        <ApproveRow
          who="STU-10802 · Neel Sharma · 9-A"
          what="Hardship concession · ₹12,500 · guardian lost job"
          amount="Impact: ₹12.5k / year"
          budget={<Tag color="processing">Policy matches: hardship band 2 · documented</Tag>}
          action="Approve"
          last
        />
      </Card>
    </div>
  );
}

function Filter({ children, active }: { children: React.ReactNode; active?: boolean }) {
  return (
    <Tag color={active ? undefined : 'default'} style={{ background: active ? '#14213d' : '#fff', color: active ? '#fff' : '#26304a', border: active ? 'none' : '1px solid #dcdde3', padding: '3px 10px', fontWeight: active ? 600 : 500, cursor: 'pointer' }}>
      {children}
    </Tag>
  );
}

function ApproveRow({ who, what, amount, budget, action, auto, last }: { who: string; what: string; amount: string; budget: React.ReactNode; action: string; auto?: boolean; last?: boolean }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr auto', gap: 12, padding: '12px 0', borderBottom: last ? 'none' : '1px solid #f1f1f4', alignItems: 'center' }}>
      <div>
        <div style={{ fontWeight: 500, fontSize: 13 }}>{who}</div>
        <Typography.Text type="secondary" style={{ fontSize: 11.5, fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}>{amount}</Typography.Text>
      </div>
      <div>
        <div style={{ fontSize: 13 }}>{what}</div>
        <div style={{ marginTop: 4 }}>{budget}</div>
      </div>
      <Button size="small" type={auto ? 'default' : 'primary'} disabled>{action}</Button>
    </div>
  );
}
